<template>
    <div style="text-align: center; padding: 80px 20px 20px 20px">
        <img style="width: 109px; height: 109px" src="../../assets/img/store/img_gzrw@3x.png"/>
        <div style="font-size: 16px">正在为您配置，请耐心等待~</div>
    </div>
</template>

<script>
    import head from '@/mixins/head';
    import {
        mapState
    } from 'vuex';

    export default {
        name: 'pay-end',
        components: {},
        mixins: [head],
        data() {
            return {};
        },
        created() {
            this.inited();
        },
        mounted() {
        },
        watch: {
            '$route': 'inited' // 如果路由有变化，会再次执行该方法
        },
        computed: {
            ...mapState({
                userInfo: state => state.userInfo
            })
        },
        methods: {
            inited() {
                setTimeout(() => {
                    // window.toStoreFunc();
                    // window.closeWindow();
                    window.toStoreFuncAndFinish();
                }, 4000);
            }
        }
    };
</script>

<style lang="scss" scoped>
</style>
